import { Modal } from 'react-bootstrap'
import {
  askConfirmationUpdate,
  cancelDeactivate,
  deactivatePromo,
  hideDeactivateModal,
  setActionUpdateName
} from 'actions/library/promo'
import styles from './DeactivateModal.css'
import { connect } from 'react-redux'
import { mapKeys } from 'lodash'
import { libraryPromoDeleteReactivateDeactivate } from 'mixpanel/library/promo'

class DeactivateModal extends React.Component {
  render () {
    const {showDeactivateModal, deactivatedPromo} = this.props
    return (<Modal show={showDeactivateModal} onHide={this._onHide} dialogClassName={`modal-dialog ${styles.dialog}`}>
      <Modal.Header bsClass={`modal-header ${styles.header}`}>
        <button
          onClick={this._onHide}
          type='button'
          className='close'
          data-dismiss='modal'
          aria-label='Close'>
          <span aria-hidden='true'>&times;</span>
        </button>
        Deactivate Promo
      </Modal.Header>
      <Modal.Body>
        {deactivatedPromo && <p>Are you sure you want to deactivate <b>{deactivatedPromo.name}</b> ?</p>}
      </Modal.Body>
      <Modal.Footer>
        <button onClick={this._onHide} className='btn btn-default'>
          Cancel
        </button>
        <button onClick={this._onConfirm} className='btn btn-danger'>
          Deactivate
        </button>
      </Modal.Footer>
    </Modal>)
  }

  _onHide = () => {
    this.props.dispatch(cancelDeactivate())
  }

  _onConfirm = () => {
    let {deactivatedPromo, dispatch, outlets, isManager, hashedPromoType, detailPromo} = this.props
    let hashedOutlets = mapKeys(outlets, 'id')
    const outletNames = []
    detailPromo.outlet_ids.forEach(oId => {
      if (hashedOutlets[oId]) {
        outletNames.push(hashedOutlets[oId].name)
      }
    })
    libraryPromoDeleteReactivateDeactivate('Promo Deactivate', {
      promoType: hashedPromoType[deactivatedPromo.promo_type_id].name,
      promoName: deactivatedPromo.name,
      outlet: outletNames
    })
    if (isManager) {
      dispatch(setActionUpdateName('deactivate'))
      dispatch(hideDeactivateModal())
      dispatch(askConfirmationUpdate(deactivatePromo(deactivatedPromo, hashedOutlets)))
    } else {
      dispatch(deactivatePromo(deactivatedPromo, hashedOutlets))
    }
  }
}

function mapStateToProps (state) {
  const {deactivatedPromo, showDeactivateModal, outlets, promoTypes, detailPromo} = state.library.promo
  const {user} = state.moka
  const isManager = user.is_manager
  const hashedPromoType = mapKeys(promoTypes, 'id')
  return {
    deactivatedPromo,
    showDeactivateModal,
    outlets,
    isManager,
    hashedPromoType,
    detailPromo
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(DeactivateModal)



// WEBPACK FOOTER //
// ./app/pages/Library/Promo/DeactivateModal/DeactivateModal.js